import { JobBlocksProps, JobBlocksVariant } from '@/features/job-blocks';
import { JobListProps } from '@/features/job-category-page/components/job-category-jobs-list';
import { jobSearchQueryFromJobCategoryPageAndRelatedJobsLevel } from '@/features/job-category-page/mappers/job-category-job-search.mapper';
import { isNurse } from '@/utils/discipline-utils';

export default function jobCategoryJobBlocksFromJobListProps(
  props: JobListProps
): JobBlocksProps {
  return {
    id: props.page.id,
    variant: JobBlocksVariant.CARD_CAROUSEL,
    jobs: props.relatedJobs || [],
    title: 'Expand your search to see more results!',
    subtitle: prepareSubtitle(props),
    ...jobSearchQueryFromJobCategoryPageAndRelatedJobsLevel(
      props.page,
      props.relatedJobsLevel
    ),
  };
}

const prepareSubtitle = ({
  page: { discipline, specialty, disciplineType },
  relatedJobsLevel,
}: JobListProps): string => {
  if (relatedJobsLevel === 'specialty') {
    return `Check out these and other great ${specialty?.title} jobs`;
  }

  if (relatedJobsLevel === 'discipline') {
    return `Check out these and other great ${discipline?.title} jobs`;
  }

  if (isNurse(disciplineType)) {
    return `Check out these and other great travel nurse jobs`;
  }

  return `Check out these and other great allied health jobs`;
};
